module.exports = __webpack_public_path__ + "static/media/mc.1a5f2602.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mc.svg
// module id = 183
// module chunks = 0